import MenuItem from "@mui/material/MenuItem";
import { IconButton } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { MoreVertIcon } from "../../../../images/MoreVertIcon";
import { StyledMenu } from "../../../../ui";
import { CRMRequestModal } from "./CRMRequestModal";
import { Integration } from "../../../../../types/enums";

enum MenuModals {
  change = "change",
  remove = "remove",
  none = "none",
}

type Props = {
  currentEmail: string;
  setCurrentEmail: (email: string, crmType: Integration) => void;
  isDisabled: boolean;
  crmType: Integration;
};

export const CRMMenu = ({
  currentEmail,
  setCurrentEmail,
  isDisabled,
  crmType,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openModal, setOpenModal] = useState<MenuModals>(MenuModals.none);
  const [currentFlow, setCurrentFlow] = useState<string>("");

  useEffect(() => {
    if (currentFlow) {
      setCurrentFlow("");
    }
  }, [currentFlow]);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const setEmailHandler = (email: string) => {
    setCurrentEmail(email, crmType);
    setOpenModal(MenuModals.none);
    setAnchorEl(null);
  };

  const onCloseHandler = () => {
    setOpenModal(MenuModals.none);
    setAnchorEl(null);
  };

  const options = [
    {
      label: "Change Email",
      onClick: () => setOpenModal(MenuModals.change),
    },
    {
      label: "Delete Email",
      onClick: () => setOpenModal(MenuModals.remove),
    },
  ];

  const modal: Record<MenuModals, ReactNode> = {
    [MenuModals.change]: (
      <CRMRequestModal
        currentEmail={currentEmail}
        setCurrentEmail={(email) => setEmailHandler(email)}
        onClose={onCloseHandler}
        isLoading={false}
        modalType={"send"}
        crmType={crmType}
      />
    ),
    [MenuModals.remove]: (
      <CRMRequestModal
        currentEmail={currentEmail}
        setCurrentEmail={() => setEmailHandler("")}
        onClose={onCloseHandler}
        isLoading={false}
        modalType={"remove"}
        crmType={crmType}
      />
    ),
    [MenuModals.none]: null,
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        disabled={isDisabled}
      >
        <MoreVertIcon width="24" />
      </IconButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "white",
          },
        }}
      >
        {options.map(({ label, onClick }) => (
          <MenuItem
            key={label}
            sx={{
              display: "flex",
              gap: "12px",
              alignItems: "center",
            }}
            onClick={onClick}
          >
            {label}
          </MenuItem>
        ))}
      </StyledMenu>

      {modal[openModal]}
    </div>
  );
};
